import moment from "moment";
import * as QueryString from "querystring";
import {InitPage} from "../index";
import axios from "axios";
import swal from "sweetalert";

declare let ercEPCtagsUrl: string;
declare let ercTransferId: any;
declare let ercTransfer: any;
declare let ercTransferUrl: string;
declare let ercTransferIndexUrl: string;
declare let ercTransferLocationFrom: string;
declare let quantityText: string;
declare let itemAvailableUomOptions: string;
declare let pendigToAddedItem: any;
declare let fetchTransferItems: any;
declare let ercTransferNotesUrl: string;
declare let clientstorerfidsbaseurl: string;
declare let clientStoreTransferPrintUrl: string;
declare let clientStoreTransferItemPrintUrl: string;
declare let ercItemPickedQty: any;
declare let ercItemPendingQty: any;
declare let ercTransferPickingsPath: string;

class ERCTransfer {
    refreshLocation = null;
    httpRequest = null;
    selectedItems = [];
    availableItems = [];

    init() {
        const self = this;

        $('#from_date, #to_date').datepicker({ dateFormat: 'mm/dd/yy' });

        $('#from-date').on('click', function (e) {
            e.preventDefault();
            $('#from_date').datepicker('show');
        });

        $('#to-date').on('click', function (e) {
            e.preventDefault();
            $('#to_date').datepicker('show');
        });

        $('.alert-icon').on('click', function(e) {
            e.preventDefault();
            $('#error-dialog').modal('show');
        });

        const _this = this;
        $('#addItemBtn').on('click', async function(e) {
            $('#itemsDataTBody').html('');
            $('#query').val('');
            $('#addItemDialog').modal('show');
        });

        $('#savePickingBtn').on('click', function() {
            $('#savePickingForm').submit();
        });

        $('#saveAndExitPickingBtn').on('click', function() {
            $('#pickingFormRedirectUri').val(ercTransferPickingsPath);
            $('#savePickingForm').submit();
        });

        $('#itemsSearchBtn').on('click', async function(e) {
            await _this.fetchItems($('#query').val().toString());
            $('#add-item-dialog').modal('show');
        });

        $('#query').on('keypress', async function(e) {
            if(e.which == 13) {
                await _this.fetchItems($('#query').val().toString());
            }
        });

        $('#saveTransferBtn').one('click', function(e) {
          e.preventDefault();
          $(this).css('pointer-events', 'none').addClass('disabled');

            if(ercTransferId) {
                _this.updateTransfer();
            } else {
                _this.createTransfer();
            }
        });

        $('#changeLocationBtn').on('click', async function(e) {
            _this.changeLocationAndRemoveItems();
        });

        $('.transfer-status-btn').on('click', function(e) {
            $('#transferStatus').val($(this).data('status'));
            var actionUrl = $('#transferStatusForm').attr('action');
            var formData = $('#transferStatusForm').serialize();
            $.ajax({
              type: 'POST',
              url: actionUrl,
              data: formData,
              success: function(response){
                  window.toastr_notifications.success("Transfer Completed Successfully", "Saved");
                  $('#print-transfer-label-dialog').modal('show');
              },
              error: function(xhr, status, error){
                  window.toastr_notifications.error(error, "Error");
              }
            });
            // $('#transferStatusForm').submit();
        });

        if (typeof fetchTransferItems != 'undefined' && fetchTransferItems == true) {
            this.fetchTransferItems(ercTransferId);
        }

        $('.print-icon').on('click', function(e) {
            const qty = $(this).data('qty');
            const number = $(this).data('number');
            const uom = $(this).data('uom');
            clientStoreTransferItemPrintUrl = $(this).data('url');

            $('#printingmodalitem').html(number);
            $('#print_job_item_number').val(number);
            $('#print_job_storage_unit').val(qty);

            $('#printingModalItemQty').html(`${qty} ${uom}`);

            $('#print-tracking-label-dialog').modal('show');
        });

        $('.print-icon2').on('click', function(e) {
            e.preventDefault();
            const qty = $(this).data('qty');
            const number = $(this).data('number');
            const uom = $(this).data('uom');

            $('#printingmodalitem').html(number);
            $('#print_job_item_number').val(number);
            $('#print_job_storage_unit').val(qty);

            $('#printingmodalitemqty').html(`${qty} ${uom}`);

            $('#print-transfer-label-dialog').modal('show');
        });

        $('.transfer-print-icon').on('click', function(e) {
            $('#print-tracking-label-dialog').modal('show');
        });

        $('.btn_print_tracking_label').on('click', function(e) {
          _this.submitPrint();
        });

        $('.btn_print_tracking_label_rfid').on('click', function(e) {
          clientStoreTransferItemPrintUrl = clientStoreTransferPrintUrl;
          _this.submitPrint();
        });

        $('.split-icon').on('click', function(e) {
            e.preventDefault();
            $('#tag-split-dialog').modal('show');
        });

        $('.find_antenna').on('click', function (event) {
          event.preventDefault();

          var antennas = [];
          var id = $(this).data('id');
          if (typeof id === 'number') {
            antennas.push(id);
          } else {
            antennas = id.split(',');
          }

          $(document).find('.reader_antenna').removeClass('command_item');
          for (var i = 0; i < antennas.length; i++) {
            var antenna = parseInt(antennas[i]);
            var reader_id = antenna / 100;
            var antenna_id = antenna % 100;
            var reader = "#reader_" + reader_id;
            var antennaTag = ".reader_antenna_" + antenna_id;
            var el = self.getReaderAntennaTag(reader);
            if (el) {
              el.addClass("circle_item_visible");
              el.find(antennaTag).addClass("command_item");
            }
          }
        });

        $('#cancelChangeLocationBtn').on('click', function(e) {
            $('#errorDialogLocation').addClass('hide')
        });

        if (typeof ercItemPendingQty != 'undefined' && ercItemPendingQty == 0) {
            $('.checkbox-field:not(:checked)').prop('disabled', true);
        }
    }

    getReaderAntennaTag(reader) {
      var readerTags = $(reader);
      var retEl = null;
      for (var i = 0; i < readerTags.length; i++) {
        var el = $(readerTags[i]);
        if (el.find('.reader_dragable_item').children().length > 0) {
          retEl = el;
        }
      }
      return retEl;
    }

    submitPrint() {
        return (<any>$("#tracking_label_print_form")).ajaxSubmit({
            url: clientStoreTransferItemPrintUrl,
            type: "post",
            dataType: "json",
            success: ({responseJSON}) => {
                $('.success-box').show();
                window.location.reload();
            },
            error: ({responseJSON}) => {
                if (responseJSON) {
                    $("#update_price_dialog").modal("hide");
                } else {
                  window.toastr_notifications.error("Error(s) in processing:', 'Something went wrong, please contact support", "Error");
                    return false;
                }

            }
        });
    }

    createTransfer() {
        var formDataArray = $('#createTransferForm').serializeArray();
        var formDataObject = this.arrayToObject(formDataArray);
        var formDataJSON = JSON.stringify(formDataObject);
        axios.post(ercTransferUrl, formDataJSON, {
          headers: {
            'Content-Type': 'application/json',
          },
        }).then(function(response) {
            location.href = ercTransferIndexUrl;
        }).catch(function(error) {
            window.toastr_notifications.error(error.response.data.error, "Error");
        });
    }

    updateTransfer() {
        var formDataArray = $('#createTransferForm').serializeArray();
        var formDataObject = this.arrayToObject(formDataArray);
        formDataObject['update_items'] = true
        var formDataJSON = JSON.stringify(formDataObject);
        axios.put(`${ercTransferUrl}/${ercTransferId}.json`, formDataJSON, {
          headers: {
            'Content-Type': 'application/json',
          },
        }).then(function(response) {
            location.href = ercTransferIndexUrl;
        }).catch(function(error) {
            window.toastr_notifications.error(error.response.data.error, "Error");
        });
    }

    pickTag(el, qty) {
        if ($(el).is(":checked") == true) {
            ercItemPickedQty += qty;
            ercItemPendingQty -= qty;
            if (ercItemPendingQty == 0) {
                $('.checkbox-field:not(:checked)').prop('disabled', true);
            }

        } else {
            ercItemPickedQty -= qty;
            ercItemPendingQty += qty;
            $('.checkbox-field:not(:checked)').prop('disabled', false);
        }

        $('#selectedTagsTd').html(ercItemPickedQty);
        $('#pendingTagsTd').html(ercItemPendingQty);
    }

    createNote() {
        var formDataArray = $('#createNoteForm').serializeArray();
        var formDataObject = this.arrayToObject(formDataArray);
        var formDataJSON = JSON.stringify(formDataObject);
        axios.post(ercTransferNotesUrl, formDataJSON, {
          headers: {
            'Content-Type': 'application/json',
          },
        }).then(function(response) {
            const note = response.data.erc_transfer_note;
            $('#transferNotesTBody').prepend(`
                <tr>
                  <td class="text-center double-lines-content">
                    ${moment(note.created_at).format('MM/DD/YYYY')}
                    <br/>
                    ${moment(note.created_at).format('h:mm A')}
                  </td>
                  <td  class="text-center">
                    ${note.important ? '<i class="fa fa-check sn-text-warning"></i>' : ''}
                  </td>
                  <td style="width: 80%">
                    <span title="${note.message}" data-toggle="tooltip" data-placement="top">${note.message}</span>
                  </td>
                </tr>
            `);
            $('#noteFormMessage').val('');
            $('#noteFormImportant').removeAttr("checked");
        }).catch(function(error) {
            window.toastr_notifications.error(error.response.data.error, "Error");
            $('#noteFormMessage').val('');
            $('#noteFormImportant').removeAttr("checked");
        });
    }

    arrayToObject(array) {
        var result = {};
        array.forEach(function(item) {
            var keys = item.name.split('[');
            var currentObj = result;
            keys.forEach(function(key, index) {
                key = key.replace(']', '');
                if (index === keys.length - 1) {
                    currentObj[key] = item.value;
                } else {
                    currentObj[key] = currentObj[key] || {};
                    currentObj = currentObj[key];
                }
            });
        });

        return result;
    }

    updateErcTransferLocationFrom() {
        ercTransferLocationFrom = $('#locationFromSelect').val().toString();
    }

    changeLocationAndRemoveItems() {
        ercTransfer.selectedItems.forEach(item => {
            ercTransfer.selectedItems = ercTransfer.selectedItems.filter(obj => obj.item_number !== item.item_number);
            $(`#selectedItemsHtmlContentTr${item.item_number}`).remove();
        });

        $('#locationFromSelect').val(ercTransfer.pendigToAddedItem.location);
        ercTransferLocationFrom = ercTransfer.pendigToAddedItem.location;
        this.addItem(ercTransfer.pendigToAddedItem.item_number, ercTransfer.pendigToAddedItem.location);
        $('#errorDialogLocation').addClass('hide');
    }

    async fetchItems(query = '') {
        const response = await axios.get(ercEPCtagsUrl + '?query=' + query);
        ercTransfer.availableItems = response.data;
        const tbody =  $('#itemsDataTBody');
        tbody.html('');

        ercTransfer.availableItems.forEach(item => {
            const row = document.createElement('tr');
            row.classList.add('center-content');
            row.innerHTML = `
              <td class="heighter">${item.item_number}</td>
              <td>${item.item_name || '-'}</td>
              <td style="text-align: left !important">${item.alu || '-'}</td>
              <td style="text-align: left !important">${item.location.code} - ${item.location.name}</td>
              <td style="text-align: left !important">${this.itemQuantitiesText(item.quantities)}</td>
              <td class="small-space sn-icons">
                <a onclick="ercTransfer.addItem('${item.item_number}', '${item.location.code}')" class="fa fa-hand-o-up fa-2x text-primary" title="Select"></a>
              </td>
            `;
            tbody.append(row);
        });
    }

    async fetchTransferItems(ercTransferId) {
        const response = await axios.get(ercEPCtagsUrl + '?transfer_id=' + ercTransferId);
        response.data.forEach(transferItem => {
            ercTransfer.selectedItems.push(transferItem);
            this.appendSelectedItem(transferItem);
        });
    }

    addItem(itemNumber, location) {
        const selectedItem = this.searchItemByNumberAndLocation(ercTransfer.availableItems, itemNumber, location);
        if(selectedItem.location.code !== ercTransferLocationFrom) {
            if(ercTransfer.selectedItems.length == 0) {
                $('#locationFromSelect').val(selectedItem.location.code);
                ercTransferLocationFrom = selectedItem.location.code;
            } else {
                $('#errorDialogLocation').removeClass('hide');
                ercTransfer.pendigToAddedItem = {
                    item_number: itemNumber,
                    location: location
                }
                return;
            }
        }

        if (!this.searchItemByNumberAndLocation(ercTransfer.selectedItems, itemNumber, location)) {
            ercTransfer.selectedItems.push(selectedItem);
            this.appendSelectedItem(selectedItem);
        }
    }

    deleteTransferItem(id, itemNumber, location) {
        swal({
          title: "Are you sure?",
          text: "This operation will delete the item!",
          icon: "warning",
          buttons: {
            cancel: {
                text: "No",
                value: false,
                visible: true,
                className: "sn-btn sn-btn-sm sn-btn-silver",
                closeModal: true
            },
            confirm: {
                text: "Yes",
                value: true,
                visible: true,
                className: "sn-btn sn-btn-sm sn-btn-danger",
                closeModal: true
            }
          },
          dangerMode: true
        }).then((isConfirmed) => {
          if (isConfirmed) {
            ercTransfer.selectedItems = ercTransfer.selectedItems.filter(obj => obj.item_number !== itemNumber);
            $(id).remove();
          }
        });
    }

   searchItemByNumberAndLocation(items, itemNumber, location) {
       return items.find(item => item.item_number === itemNumber && item.location.code === location);
   }

   itemQuantitiesText(quantities) {
     return quantities.map((quantity: any) => `${quantity.qty} ${quantity.uom}`).join(', ');
   }

   removeERCTransfer(id) {

   }

   appendSelectedItem(item) {
        var selectedItemsHtmlContent = $('#itemsSelectedTBody');
        var itemAvailableUomOptions = '';
        item.quantities.forEach(quantity => {
           itemAvailableUomOptions = itemAvailableUomOptions.concat(`<option value="${quantity.uom}" ${quantity.uom == item.erc_transfer_item.uom ? 'selected' : ''}>${quantity.uom}</option>`);
        });

        selectedItemsHtmlContent.append(`
            <tr class="center-content" id="selectedItemsHtmlContentTr${item.item_number}">
                <td class="heighter">${item.item_number}</td>
                <td>${item.item_number}</td>
                <td>${item.alu || '-'}</td>
                <td style="text-align: left !important">${item.item_name || '-'}</td>
                <td>${this.itemQuantitiesText(item.quantities)}</td>
                <td>
                    <input type="text" name="items[${item.item_number}][requested_qty]" value="${item.erc_transfer_item.requested_qty || item.quantities[0].qty}" class="form-control text-center" autocomplete="requested qty">
                </td>
                <td>
                    <input name="items[${item.item_number}][item_number]" value="${item.item_number}" type="hidden" />
                    <select name="items[${item.item_number}][uom]" class="form-control">
                    ${itemAvailableUomOptions}
                    </select>
                </td>
                <td class="small-space sn-icons">
                    <a class="fa fa-minus-circle fa-2x delete-icon deleteRecordDialog"
                    title="Delete"
                    onclick="ercTransfer.deleteTransferItem(selectedItemsHtmlContentTr${item.item_number}, ${item.item_number}, ${ercTransferLocationFrom})"
                    href="#"></a>
                </td>
            </tr>
        `)
    }
}

export function LoadPage() {
    InitPage("erc transfers new", () => {
        const transfer = new ERCTransfer();
        transfer.init();
    });
}

(window as any).ercTransfer = new ERCTransfer();
